import React, { useEffect, useState } from 'react';

import './styles.css';
import UpperSection from '../UpperSection';
import LowerSection from '../LowerSection';

const COLUMNS = [
    'Up',
    'Down',
    'Free',
    'Announce',
  ];


type Props = {
  totalScore: number;
  setTotalScore: any;
};

const ScoreBoard = ({
  totalScore,
  setTotalScore,
}: Props) => {
  const [upperSectionScore, setUpperSectionScore] = useState<number>(0);
  const [onesScore, setOnesScore] = useState<number>(0);
  const [lowerSectionScore, setLowerSectionScore] = useState<number>(0);

  useEffect(() => {
    const bonus = upperSectionScore >= 63 ? 30 : 0;
    setTotalScore(upperSectionScore + lowerSectionScore + bonus)
  }, [setTotalScore, upperSectionScore, lowerSectionScore]);

  return (
    <div className={'score-board'}>
      <UpperSection
        columns={COLUMNS}
        sectionName={'Upper Section'}
        onesScore={onesScore}
        setOnesScore={setOnesScore}
        sectionScore={upperSectionScore}
        setSectionScore={setUpperSectionScore}/>
      <LowerSection
        columns={COLUMNS}
        sectionName={'Lower Section'}
        onesScore={onesScore}
        sectionScore={lowerSectionScore}
        setSectionScore={setLowerSectionScore}/>
    </div>
  );
};

export default ScoreBoard;